import type {
	GoalComposition,
	GoalCompositionInput,
} from "web_myplann/Goals/Types/GoalComposition";

export const mapToGoalComposition = (
	goal: GoalCompositionInput,
): GoalComposition | null => {
	const price = goal.price ?? 0;
	if (price <= 0) return null;

	const remaining = Math.max(
		0,
		price - goal.ownFunds - goal.loanAmount - goal.coveredAmount,
	);

	return {
		ownFunds: goal.ownFunds,
		loanAmount: goal.loanAmount,
		coveredAmount: goal.coveredAmount,
		remaining,
		coveredPercent: Math.min(
			100,
			Math.round(((price - remaining) / price) * 100),
		),
	};
};
